import { TEXTOS } from '../../manual-textos';
import { itensValidos, ou } from '../../manual-utils';
import {
  blocoCapitulo,
  blocoDefinicoes,
  blocoSecao,
  blocoTabela,
  blocoTexto,
} from '../blocos';
import type { Bloco } from '../blocos';
import type { ManualData } from '../../manual-types';

export function capitulo8(dados: ManualData): Bloco[] {
  if (!dados.opcoes.incluirGlossario && !dados.opcoes.incluirAbreviaturas) return [];
  const blocos: Bloco[] = [blocoCapitulo(8, 'Glossário e abreviaturas')];
  blocos.push(...blocoTexto(TEXTOS.aberturaGlossario, 'c8-abertura'));

  if (dados.opcoes.incluirGlossario) {
    blocos.push(blocoSecao('8.1', 'Glossário'));
    blocos.push(...blocoDefinicoes(
      itensValidos(dados.glossario, ['termo', 'definicao']).map((item) => ({ termo: item.termo, definicao: item.definicao })),
      'c8-glossario',
    ));
  }

  if (dados.opcoes.incluirAbreviaturas) {
    blocos.push(blocoSecao(dados.opcoes.incluirGlossario ? '8.2' : '8.1', 'Abreviaturas'));
    blocos.push(...blocoTabela({
      id: 'c8-abreviaturas',
      colunas: ['SIGLA', 'SIGNIFICADO'],
      linhas: itensValidos(dados.abreviaturas, ['termo', 'definicao']).map((item) => [ou(item.termo, '—'), ou(item.definicao, '—')]),
      larguras: ['20%', '80%'],
      alinharEsquerda: true,
      porPagina: 20,
    }));
  }

  return blocos;
}
